import React, { useState, useMemo, useEffect, useRef } from "react";
import "./EpisodeList.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import closeIcon from "../../../common/assets/images/x-close.png";
import { Grid, Typography, TextField } from "@mui/material";
import debounce from "lodash.debounce";
import {
  Container,
  Modal,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Button,
  Badge,
} from "react-bootstrap";
import { formatCalenderDate } from "./Util";
import Select from "react-select";
import {
  getFilterEpisodeLists,
  resetEpisodeListFilters,
  setEpisodeListFilterObj,
  getDocumentTypesFilterOptions,
  setDocumentTypesFilterSearch,
  resetFilterByDocumentTypes,
} from "./redux/EpisodeListSlicer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import MultiSelect from "../../../utils/MultiSelect";
import {
  getEpisodeIdentiferFilterOptions,
  getHealthFundContractFilterOptions,
  getMRNFilterOptions,
  getProvisionalDrgFilterOptions,
  getSpecialityFilterOptions,
  getStatusFilterOptions,
  resetFilterByKey,
  setEpisodeIdentiferFilterSearch,
  setHealthFundFilterContractSearch,
  setMRNFilterSearch,
  setProvisionalDrgFilterSearch,
  setSpecialityFilterSearch,
  setStatusFilterSearch,
} from "../../Codeworkflow/HealthInsuranceManager/redux/HealthInformationManagerSlicer";

const EpisodeListFilter = ({
  showepisodeListFilter,
  setShowepisodeListFilter,
  closeEpisodeFilterModal,
  setCoderSearchTerm,
}) => {
  const dispatch = useDispatch();
  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  // const {
  //   sort_by,
  //   sort_order,
  //   page_size,
  //   episode_identifier,
  //   page,
  //   module_name,
  //   ...newepisodeListFilterObj
  // } = episodeListFilterObj;
  const { documentTypesFilterOptions } = useSelector(
    (state) => state.episodeList,
  );
  console.log(documentTypesFilterOptions, "documentTypesFilterOptions");
  const {
    episodeIdentiferFilterOptions,
    MRNFilterOptions,
    specialityFilterOptions,
    queueFilterOptions,
    coderFilterOptions,
    priorityFilterOptions,
    statusFilterOptions,
    healthFundContractFilterOptions,
    provisionalDrgFilterOptions,
    auditorsFilterOptions,
  } = useSelector((state) => state.healthInsuranceManager);
  const dateFormat = "dd/MM/yyyy";
  const location = useLocation();

  const labelCache = useRef({
    speciality: {},
    // queue: {},
    // coder: {},
    status: {},
  });

  const breadcrumbExcludeKeys = [
    "page",
    "page_size",
    "sort_by",
    "sort_order",
    "module_name",
  ];

  const losOperatorOptions = [
    { label: ">", value: "gt" },
    { label: "<", value: "lt" },
    { label: ">=", value: "gte" },
    { label: "<=", value: "lte" },
    { label: "=", value: "eq" },
    { label: "!=", value: "neq" },
    { label: "Between", value: "gtlt" },
    { label: "Between (Inclusive)", value: "gtelte" },
  ];

  const getLabel = (key, value) => {
    // map keys for lookup
    const mappedKey =
      key === "status" ? "status" : key === "speciality" ? "speciality" : key;

    // date format
    if (
      key === "separation_date_from" ||
      key === "separation_date_to" ||
      key === "admission_date_from" ||
      key === "admission_date_to"
    ) {
      const [y, m, d] = value.split("-");
      return `${d}/${m}/${y}`;
    }

    // label lookup
    const option = labelMaps[mappedKey]?.find((o) => o.value === value);

    return option ? option.label : value;
  };

  const displayKeyMap = {
    episode_identifier: "Episode Identifier",
    medical_record_number: "MRN/UR",
    speciality: "Speciality",
    status: "Status",
    health_fund_contract: "Health Fund Contract",
    drg: "Provisional DRG",
    document_name: "Document Name",
  };

  const getLosBreadcrumbText = (operator, losArray) => {
    if (
      !operator ||
      !Array.isArray(losArray) ||
      !losArray.some((v) => typeof v === "number" && !isNaN(v))
    ) {
      return null;
    }
    const opText =
      losOperatorOptions.find((option) => option.value === operator)?.label ||
      operator;

    // Single value
    if (losArray.length === 1) {
      return `${opText} ${losArray[0]} days`;
    }

    // Range
    if (losArray.length === 2) {
      return `${opText} ${losArray[0]} and ${losArray[1]} days`;
    }

    return null;
  };

  const episodeIdentiferFieldOptions = useMemo(() => {
    const apiOptions = (episodeIdentiferFilterOptions.data || []).map(
      (item) => ({
        label: item,
        value: item,
      }),
    );

    const episode_identifier = [].concat(
      episodeListFilterObj?.episode_identifier || [],
    );

    const selectedOptions = episode_identifier.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    episodeIdentiferFilterOptions.data,
    episodeListFilterObj?.episode_identifier,
  ]);

  const MRNFieldOptions = useMemo(() => {
    const apiOptions = (MRNFilterOptions.data || []).map((item) => ({
      label: item,
      value: item,
    }));

    const medical_record_number = [].concat(
      episodeListFilterObj?.medical_record_number || [],
    );

    const selectedOptions = medical_record_number.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [MRNFilterOptions.data, episodeListFilterObj?.medical_record_number]);

  const specialityFieldOptions = useMemo(() => {
    const apiOptions = (specialityFilterOptions?.data || []).map((item) => {
      labelCache.current.speciality[item.hospital_speciality_id] =
        item.speciality;

      return {
        label: item.speciality,
        value: item.hospital_speciality_id,
      };
    });

    const selectedOptions = (episodeListFilterObj?.speciality || []).map(
      (value) => ({
        value,
        label: labelCache.current.speciality[value] || value,
      }),
    );

    const map = new Map();
    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [specialityFilterOptions?.data, episodeListFilterObj?.speciality]);

  const statusFiledOptions = useMemo(() => {
    const apiOptions = (statusFilterOptions?.data || []).map((item) => {
      labelCache.current.status[item?.status_id] = item.status;

      return {
        label: item.status,
        value: item.status_id,
      };
    });

    const selectedOptions = (episodeListFilterObj?.status || []).map(
      (value) => ({
        value,
        label: labelCache.current.status[value] || value,
      }),
    );

    console.log(selectedOptions, "selectedOptions status");

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [statusFilterOptions.data, episodeListFilterObj?.status]);

  const healthFundFieldOptions = useMemo(() => {
    const apiOptions = healthFundContractFilterOptions?.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = Array.isArray(
      episodeListFilterObj?.health_fund_contract,
    )
      ? episodeListFilterObj.health_fund_contract.map((value) => ({
          label: value,
          value: value,
        }))
      : [];

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    healthFundContractFilterOptions.data,
    episodeListFilterObj?.health_fund_contract,
  ]);

  const provisionalDrgFieldOptions = useMemo(() => {
    const apiOptions = provisionalDrgFilterOptions?.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = Array.isArray(episodeListFilterObj?.drg)
      ? episodeListFilterObj.drg.map((value) => ({
          label: value,
          value: value,
        }))
      : [];

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [provisionalDrgFilterOptions.data, episodeListFilterObj?.drg]);

  const documentTypesFieldOptions = useMemo(() => {
    const apiOptions = documentTypesFilterOptions?.data.map((item) => ({
      label: item,
      value: item,
    }));

   const selectedOptions = (episodeListFilterObj?.document_name || []).map(
  (value) => ({
    value,
    label: labelCache.current.document_name?.[value] || value,
  }),
);

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [documentTypesFilterOptions.data, episodeListFilterObj?.document_name]);

  useEffect(() => {
    if (showepisodeListFilter) {
      // dispatch(resetHimFilters());
      // dispatch(resetFilterByKey("queueFilterOptions"));
      dispatch(
        getEpisodeIdentiferFilterOptions({
          search: episodeIdentiferFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getMRNFilterOptions({
          search: MRNFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getSpecialityFilterOptions({
          search: specialityFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getStatusFilterOptions({
          search: statusFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getHealthFundContractFilterOptions({
          search: healthFundContractFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getProvisionalDrgFilterOptions({
          search: provisionalDrgFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getDocumentTypesFilterOptions({
          search: provisionalDrgFilterOptions.search,
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  }, [showepisodeListFilter, dispatch]);

  const transformLosForApi = (operator, value, toValue = "") => {
    const los = [];

    if (!operator || value === "" || value === undefined) return [];

    const losValue =
      value === "no_los" || value === null ? "No_los" : Number(value);

    const isRange = operator === "gtlt" || operator === "gtelte";

    if (isRange) {
      if (toValue === "") return [];
      const losToValue =
        toValue === "no_los" || toValue === null ? "No_los" : Number(toValue);
      los.push(losValue, losToValue);
    } else {
      los.push(losValue);
    }
    return los;
  };

  const debouncedSearchRef = useRef(
    debounce((thunk, value) => {
      dispatch(
        thunk({
          search: value || "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }, 400),
  );

  const handleInputChange =
    (setSearchAction, fetchThunk) =>
    (value, { action }) => {
      if (action !== "input-change") {
        return;
      }

      dispatch(setSearchAction(value || ""));
      debouncedSearchRef.current(fetchThunk, value);
    };

  const handleScrollBottom = (options, thunk) => () => {
    if (options.hasMore && !options.loading) {
      dispatch(
        thunk({
          search: options.search || "",
          page_number: options.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnFocus = (optionsState, fetchThunk) => {
    if (optionsState?.data?.length === 0 && !optionsState.loading) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnChange = async ({
    key,
    selected,
    optionsState,
    fetchThunk,
    searchResetAction,
    minVisible = 4,
  }) => {
    const selectedArray = selected || [];

    const selectedValues =
      key === "speciality" || key === "status"
        ? selectedArray.map((s) => s.value)
        : selectedArray.map((s) => s.label);

    const finalValues = selectedValues;
    // dispatch(setEpisodeListFilterObj({ [key]: finalValues }));
    dispatch(
      setEpisodeListFilterObj({
        ...episodeListFilterObj,
        [key]: finalValues,
      }),
    );


    if (optionsState.search) {
      dispatch(searchResetAction(""));
      debouncedSearchRef.current?.cancel?.();

      let currentPage = 1;
      let hasMore = true;
      let accumulatedData = [];

      while (hasMore) {
        const response = await dispatch(
          fetchThunk({
            search: "",
            page_number: currentPage,
            page_size: 10,
          }),
        ).unwrap();

        const dataMap = {
          episode_identifier: response.episode_identifier_number,
          medical_record_number: response.medical_record_number,
          speciality: response?.queues?.specialities,
          status: response?.queues?.status,
          health_funds: response?.queues?.specialities,
          drg: response?.queues?.drg_codes,
        };

        const pageData = dataMap[key] || [];
        accumulatedData = [...accumulatedData, ...pageData];
        hasMore = response.has_more;
        const visibleOptions = accumulatedData.filter((item) => {
          const compareValue =
            key === "speciality" || key === "status" ? item.value : item;

          return !selectedValues.includes(compareValue);
        });

        if (visibleOptions.length >= minVisible) break;
        if (!hasMore) break;

        currentPage += 1;
      }
      return;
    }
    
    const visibleOptions = optionsState.data.filter((item) => {
  let compareValue;

  if (typeof item === "object") {
    if (key === "speciality") {
      compareValue = item.hospital_speciality_id;
    } else if (key === "status") {
      compareValue = item.status_id;
    } else {
      compareValue = item.value || item.label;
    }
  } else {
    compareValue = item;
  }

  return !selectedValues.includes(compareValue);
});

    if (
      visibleOptions.length < minVisible &&
      optionsState.hasMore &&
      !optionsState.loading
    ) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: optionsState.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleResetOnBlur = (stateKey, searchResetAction) => () => {
    debouncedSearchRef.current?.cancel?.();
    dispatch(searchResetAction(""));
    if (stateKey === "documentTypesFilterOptions") {
      dispatch(resetFilterByDocumentTypes(stateKey));
    } else {
      dispatch(resetFilterByKey(stateKey));
    }
  };
  const EpisodeListFilterSubmit = (e) => {
    const payload = {
      ...episodeListFilterObj,
      length_of_stay: transformLosForApi(
        episodeListFilterObj.los_op,
        episodeListFilterObj.length_of_stay?.[0],
        episodeListFilterObj.length_of_stay?.[1],
      ),
      page: 1,
    };

    // const trimmedData = Object.keys(episodeListFilterObj).reduce((acc, key) => {
    //   const value = payload[key];
    //   acc[key] = typeof value === 'string' ? value.trim() : value;
    //   return acc;
    // }, {});
    e.preventDefault();
    setCoderSearchTerm("");
    dispatch(getFilterEpisodeLists(payload));
    // closeEpisodeFilterModal();
    setShowepisodeListFilter(false);
  };

  const handleEpisodeListFilterChange = (name, value) => {
    dispatch(
      setEpisodeListFilterObj({
        ...episodeListFilterObj,
        page: 1,
        [name]: value,
      }),
    );
  };

  const handleCheckboxChange = (name, item) => {
    // const updatedList = episodeListFilterObj[name]?.includes(item)
    //   ? episodeListFilterObj[name].filter((value) => value !== item)
    //   : [...episodeListFilterObj[name], item];

    dispatch(
      setEpisodeListFilterObj({
        ...episodeListFilterObj,
        page: 1,
        [name]: item,
      }),
    );
  };

  const handleReset = () => {
    dispatch(resetEpisodeListFilters());
  };

  const labelMaps = {
    episode_identifier: episodeIdentiferFieldOptions,
    medical_record_number: MRNFieldOptions,
    speciality: specialityFieldOptions,
    status: statusFiledOptions,
    // health_fund_contract: healthFundFieldOptions,
    los_op: losOperatorOptions,
    drg: provisionalDrgFieldOptions,
    document_name: documentTypesFieldOptions,
  };

  const handleFilterRemove = (filterName, item) => {
    const updatedFilterObj = { ...episodeListFilterObj };
    if (Array.isArray(updatedFilterObj[filterName])) {
      // If the filter is an array, filter out the specific item
      updatedFilterObj[filterName] = updatedFilterObj[filterName].filter(
        (value) => value !== item,
      );
    } else {
      // If it's not an array, reset the value to the default value ("" or null)
      updatedFilterObj[filterName] = filterName === "date" ? null : "";
    }
    // Update the state with the modified filter object
    dispatch(setEpisodeListFilterObj(updatedFilterObj));
  };
  const hasValue = Object.entries(episodeListFilterObj).some(
    ([key, val]) =>
      !breadcrumbExcludeKeys?.includes(key) &&
      (Array.isArray(val) ? val?.length > 0 : !!val),
  );

  return (
    <div className="episode-list-filter-container">
      <Modal
        show={showepisodeListFilter}
        onHide={closeEpisodeFilterModal}
        backdrop="static"
        className="episode-list-filter-modal"
        // size="lg"
        dialogClassName="modal-xl"
        keyboard={false}
      >
        <Modal.Header closeButton className="episode-list-modal-header">
          <Modal.Title className="episode-list-filter-modal-title">
            Episode Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {hasValue && (
            <div className="episodelist-filter-breadcrumb-section-him">
              <div className="episodelist-breadcrumb-list-him">
                {Object.entries(episodeListFilterObj)
                  .filter(([key]) => !breadcrumbExcludeKeys.includes(key))
                  .map(([key, value]) => {
                    if (!value || (Array.isArray(value) && value.length === 0))
                      return null;

                    if (key === "length_of_stay") return null;

                    if (key === "los_op") {
                      const losText = getLosBreadcrumbText(
                        episodeListFilterObj.los_op,
                        episodeListFilterObj.length_of_stay,
                      );
                      if (!losText) return null;

                      return (
                        <Badge
                          key="length_of_stay"
                          bg="light"
                          text="dark"
                          className="episodeListFilterObj-breadcrumbItem-him"
                        >
                          LOS : {losText}
                          <img
                            src={closeIcon}
                            className="episodeListFilterObj-close-icon-him"
                            onClick={() => {
                              dispatch(
                                setEpisodeListFilterObj({
                                  los_op: "",
                                  length_of_stay: [],
                                }),
                              );
                            }}
                          />
                        </Badge>
                      );
                    }

                    // Date fields
                    if (
                      key === "separation_from_date" ||
                      key === "separation_to_date" ||
                      key === "admission_from_date" ||
                      key === "admission_to_date"
                    ) {
                      const [y, m, d] = value.split("-");
                      return (
                        <Badge
                          key={key}
                          bg="light"
                          text="dark"
                          className="episodeListFilterObj-breadcrumbItem-him"
                        >
                          {/* {key.replace(/_/g, " ")} : {`${d}/${m}/${y}`} */}
                          {displayKeyMap[key] || key.replace(/_/g, " ")} :{" "}
                          {getLabel(key, value)}
                          <img
                            src={closeIcon}
                            className="episodeListFilterObj-close-icon-him"
                            onClick={() =>
                              dispatch(setEpisodeListFilterObj({ [key]: null }))
                            }
                          />
                        </Badge>
                      );
                    }

                    if (Array.isArray(value)) {
                      return value.map((item) => (
                        <Badge
                          key={`${key}-${item}`}
                          bg="light"
                          text="dark"
                          className="episodeListFilterObj-breadcrumbItem-him"
                        >
                          {displayKeyMap[key] || key.replace(/_/g, " ")} :{" "}
                          {getLabel(key, item)}
                          <img
                            src={closeIcon}
                            className="episodeListFilterObj-close-icon-him"
                            onClick={() =>
                              dispatch(
                                setEpisodeListFilterObj({
                                  [key]: value.filter((v) => v !== item),
                                }),
                              )
                            }
                          />
                        </Badge>
                      ));
                    }

                    // 🔹 Single-value filters
                    return (
                      <Badge
                        key={key}
                        bg="light"
                        text="dark"
                        className="episodeListFilterObj-breadcrumbItem-him"
                      >
                        {/* {key.replace(/_/g, " ")} : {getLabel(key, value)} */}
                        {displayKeyMap[key] || key.replace(/_/g, " ")} :{" "}
                        {getLabel(key, value)}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon-him"
                          onClick={() =>
                            dispatch(setEpisodeListFilterObj({ [key]: "" }))
                          }
                        />
                      </Badge>
                    );
                  })}
              </div>

              <Button className="episodelist-reset-btn" onClick={handleReset}>
                Clear All
              </Button>
            </div>
          )}

          <form
          // onSubmit={EpisodeListFilterSubmit}
          >
            <Grid container spacing={1} size={{ xs: 12, sm: 12, md: 12 }}>
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <label
                  htmlFor="medical_record_number"
                  className="episodelist-filter-label"
                >
                  {/* medical_record_number */}
                  Episode Identifier
                </label>
                <MultiSelect
                  isMulti={true}
                  options={episodeIdentiferFieldOptions}
                  isLoading={episodeIdentiferFilterOptions.loading}
                  hasMore={episodeIdentiferFilterOptions.hasMore}
                  placeholder="Search episode identifer"
                  onScrollBottom={handleScrollBottom(
                    episodeIdentiferFilterOptions,
                    getEpisodeIdentiferFilterOptions,
                  )}
                  onInputChange={handleInputChange(
                    setEpisodeIdentiferFilterSearch,
                    getEpisodeIdentiferFilterOptions,
                  )}
                  onFocus={() => {
                    handleOnFocus(
                      episodeIdentiferFilterOptions,
                      getEpisodeIdentiferFilterOptions,
                    );
                  }}
                  onBlur={handleResetOnBlur(
                    "episodeIdentiferFilterOptions",
                    setEpisodeIdentiferFilterSearch
                  )}
                  onChange={(selected) => {
                    handleOnChange({
                      key: "episode_identifier",
                      selected,
                      optionsState: episodeIdentiferFilterOptions,
                      fetchThunk: getEpisodeIdentiferFilterOptions,
                      searchResetAction: setEpisodeIdentiferFilterSearch,
                    });
                  }}
                  value={episodeIdentiferFieldOptions?.filter((o) =>
                    episodeListFilterObj?.episode_identifier?.includes(
                      o?.value,
                    ),
                  )}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6}}>
                <label
                  htmlFor="medical_record_number"
                  className="episodelist-filter-label"
                >
                  {/* medical_record_number */}
                  MRN/UR
                </label>
                <MultiSelect
                  isMulti={true}
                  options={MRNFieldOptions}
                  isLoading={MRNFilterOptions.loading}
                  hasMore={MRNFilterOptions.hasMore}
                  placeholder="Search MRN"
                  onScrollBottom={handleScrollBottom(
                    MRNFilterOptions,
                    getMRNFilterOptions,
                  )}
                  onInputChange={handleInputChange(
                    setMRNFilterSearch,
                    getMRNFilterOptions,
                  )}
                  onFocus={() => {
                    handleOnFocus(MRNFilterOptions, getMRNFilterOptions);
                  }}
                  onBlur={handleResetOnBlur(
                    "MRNFilterOptions",
                    setMRNFilterSearch
                  )}
                  onChange={(selected) => {
                    handleOnChange({
                      key: "medical_record_number",
                      selected,
                      optionsState: MRNFilterOptions,
                      fetchThunk: getMRNFilterOptions,
                      searchResetAction: setMRNFilterSearch,
                    });
                  }}
                  value={MRNFieldOptions?.filter((o) =>
                    episodeListFilterObj?.medical_record_number?.includes(
                      o.value,
                    ),
                  )}
                />
              </Grid>
              {/* Admission Date */}
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label
                  htmlFor="admission_from_date"
                  className="episodelist-filter-label"
                >
                  Admission Date From
                </label>
                <DatePicker
                  selected={episodeListFilterObj.admission_from_date || ""}
                  onChange={(date) =>
                    handleEpisodeListFilterChange(
                      "admission_from_date",
                      formatCalenderDate(date),
                    )
                  }
                  dateFormat={dateFormat}
                  className="episode-filter-date-picker"
                  placeholderText="Admission Date From"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label
                  htmlFor="admission_to_date"
                  className="episodelist-filter-label"
                >
                  Admission Date To
                </label>
                <div
                  className={`${
                    !episodeListFilterObj.admission_from_date
                      ? "datepicker-tooltip"
                      : ""
                  }`}
                  data-title={
                    "'To date' cannot be selected until 'Admission from date' is selected"
                  }
                >
                  <DatePicker
                    selected={episodeListFilterObj.admission_to_date || ""}
                    onChange={(date) =>
                      handleEpisodeListFilterChange(
                        "admission_to_date",
                        formatCalenderDate(date),
                      )
                    }
                    dateFormat={dateFormat}
                    className="episode-filter-date-picker"
                    placeholderText="Admission Date To"
                    disabled={!episodeListFilterObj.admission_from_date}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    minDate={episodeListFilterObj?.admission_from_date ?? null}
                    maxDate={new Date()}
                    onKeyDown={(e) =>
                      e.key !== "Backspace" && e.preventDefault()
                    }
                  />
                </div>
              </Grid>

              {/* Discharge Date */}
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label
                  htmlFor="separation_from_date"
                  className="episodelist-filter-label"
                >
                  Discharge Date From
                </label>
                <DatePicker
                  selected={episodeListFilterObj.separation_from_date || ""}
                  onChange={(date) =>
                    handleEpisodeListFilterChange(
                      "separation_from_date",
                      formatCalenderDate(date),
                    )
                  }
                  dateFormat={dateFormat}
                  className="episode-filter-date-picker"
                  placeholderText="Separation Date From"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  maxDate={new Date()}
                  minDate={
                    episodeListFilterObj?.admission_from_date ??
                    episodeListFilterObj?.admission_from_date
                  }
                  onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label
                  htmlFor="separation_to_date"
                  className="episodelist-filter-label"
                >
                  Discharge Date To
                </label>
                <div
                  className={`${
                    !episodeListFilterObj.separation_from_date
                      ? "datepicker-tooltip"
                      : ""
                  }`}
                  data-title={
                    "'To date' cannot be selected until 'Separation from date' is selected"
                  }
                >
                  <DatePicker
                    selected={episodeListFilterObj.separation_to_date || ""}
                    onChange={(date) =>
                      handleEpisodeListFilterChange(
                        "separation_to_date",
                        formatCalenderDate(date),
                      )
                    }
                    dateFormat={dateFormat}
                    className="episode-filter-date-picker"
                    placeholderText="Separation Date To"
                    disabled={!episodeListFilterObj.separation_from_date}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={new Date()}
                    minDate={episodeListFilterObj?.separation_from_date}
                    onKeyDown={(e) =>
                      e.key !== "Backspace" && e.preventDefault()
                    }
                  />
                </div>
              </Grid>

              {/* Speciality Type */}
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label
                  htmlFor="speciality"
                  className="episodelist-filter-label"
                >
                  Speciality
                </label>
                <MultiSelect
                  isMulti={true}
                  options={specialityFieldOptions}
                  isLoading={specialityFilterOptions.loading}
                  hasMore={specialityFilterOptions.hasMore}
                  placeholder="Search speciality"
                  onScrollBottom={handleScrollBottom(
                    specialityFilterOptions,
                    getSpecialityFilterOptions,
                  )}
                  onInputChange={handleInputChange(
                    setSpecialityFilterSearch,
                    getSpecialityFilterOptions,
                  )}
                  onFocus={() => {
                    handleOnFocus(
                      specialityFilterOptions,
                      getSpecialityFilterOptions,
                    );
                  }}
                  onBlur={handleResetOnBlur(
                    "specialityFilterOptions",
                    setSpecialityFilterSearch
                  )}
                  onChange={(selected) => {
                    handleOnChange({
                      key: "speciality",
                      selected,
                      optionsState: specialityFilterOptions,
                      fetchThunk: getSpecialityFilterOptions,
                      searchResetAction: setSpecialityFilterSearch,
                    });
                  }}
                  value={specialityFieldOptions.filter((o) =>
                    episodeListFilterObj.speciality?.includes(o.value),
                  )}
                />
              </Grid>

              {/* Status */}
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label htmlFor="status" className="episodelist-filter-label">
                  Status
                </label>
                <MultiSelect
                  isMulti={true}
                  options={statusFiledOptions}
                  isLoading={statusFilterOptions.loading}
                  hasMore={statusFilterOptions.hasMore}
                  placeholder="Search Status"
                  onScrollBottom={handleScrollBottom(
                    statusFilterOptions,
                    getStatusFilterOptions,
                  )}
                  onInputChange={handleInputChange(
                    setStatusFilterSearch,
                    getStatusFilterOptions,
                  )}
                  onFocus={() => {
                    handleOnFocus(statusFilterOptions, getStatusFilterOptions);
                  }}
                  onBlur={handleResetOnBlur(
                    "statusFilterOptions",
                    setStatusFilterSearch
                  )}
                  onChange={(selected) => {
                    handleOnChange({
                      key: "status",
                      selected,
                      optionsState: statusFilterOptions,
                      fetchThunk: getStatusFilterOptions,
                      searchResetAction: setStatusFilterSearch,
                    });
                  }}
                  value={statusFiledOptions?.filter((o) =>
                    episodeListFilterObj?.status?.includes(o?.value),
                  )}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label htmlFor="status" className="episodelist-filter-label">
                  Health Fund Contract
                </label>
                <MultiSelect
                  isMulti={true}
                  options={healthFundFieldOptions}
                  isLoading={healthFundContractFilterOptions.loading}
                  hasMore={healthFundContractFilterOptions.hasMore}
                  placeholder="Search Health Fund Contract"
                  onScrollBottom={handleScrollBottom(
                    healthFundContractFilterOptions,
                    getHealthFundContractFilterOptions,
                  )}
                  onInputChange={handleInputChange(
                    setHealthFundFilterContractSearch,
                    getHealthFundContractFilterOptions,
                  )}
                  onFocus={() => {
                    handleOnFocus(
                      healthFundContractFilterOptions,
                      getHealthFundContractFilterOptions,
                    );
                  }}
                  onBlur={handleResetOnBlur(
                    "healthFundContractFilterOptions",
                    setHealthFundFilterContractSearch
                  )}
                  onChange={(selected) => {
                    handleOnChange({
                      key: "health_fund_contract",
                      selected,
                      optionsState: healthFundContractFilterOptions,
                      fetchThunk: getHealthFundContractFilterOptions,
                      searchResetAction: setHealthFundFilterContractSearch,
                    });
                  }}
                  value={healthFundFieldOptions.filter((o) =>
                    episodeListFilterObj.health_fund_contract?.includes(
                      o.value,
                    ),
                  )}
                />
              </Grid>

              {/* DRG */}
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label htmlFor="drg" className="episodelist-filter-label">
                  DRG
                </label>
                <MultiSelect
                  isMulti={true}
                  options={provisionalDrgFieldOptions}
                  isLoading={provisionalDrgFilterOptions.loading}
                  hasMore={provisionalDrgFilterOptions.hasMore}
                  placeholder="Search DRG"
                  onScrollBottom={handleScrollBottom(
                    provisionalDrgFilterOptions,
                    getProvisionalDrgFilterOptions,
                  )}
                  onInputChange={handleInputChange(
                    setProvisionalDrgFilterSearch,
                    getProvisionalDrgFilterOptions,
                  )}
                  onFocus={() => {
                    handleOnFocus(
                      provisionalDrgFilterOptions,
                      getProvisionalDrgFilterOptions,
                    );
                  }}
                  onBlur={handleResetOnBlur(
                    "provisionalDrgFilterOptions",
                    setProvisionalDrgFilterSearch
                  )}
                  onChange={(selected) => {
                    handleOnChange({
                      key: "drg",
                      selected,
                      optionsState: provisionalDrgFilterOptions,
                      fetchThunk: getProvisionalDrgFilterOptions,
                      searchResetAction: setProvisionalDrgFilterSearch,
                    });
                  }}
                  value={provisionalDrgFieldOptions.filter((o) =>
                    episodeListFilterObj.drg?.includes(o.value),
                  )}
                />
              </Grid>

              {/* Document Types */}
              {location.pathname != "/Code-Assist-Episode-list" && (
                <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                  <label
                    htmlFor="document_name"
                    className="episodelist-filter-label"
                  >
                    Document Types
                  </label>
                  <MultiSelect
                    isMulti={true}
                    options={documentTypesFieldOptions}
                    isLoading={documentTypesFilterOptions.loading}
                    hasMore={documentTypesFilterOptions.hasMore}
                    placeholder="Search Documents"
                    onScrollBottom={handleScrollBottom(
                      documentTypesFilterOptions,
                      getDocumentTypesFilterOptions,
                    )}
                    onInputChange={handleInputChange(
                      setDocumentTypesFilterSearch,
                      getDocumentTypesFilterOptions,
                    )}
                    onFocus={() => {
                      handleOnFocus(
                        documentTypesFilterOptions,
                        getDocumentTypesFilterOptions,
                      );
                    }}
                    onBlur={handleResetOnBlur(
                      "documentTypesFilterOptions",
                      setDocumentTypesFilterSearch
                    )}
                    onChange={(selected) => {
                      handleOnChange({
                        key: "document_name",
                        selected,
                        optionsState: documentTypesFilterOptions,
                        fetchThunk: getDocumentTypesFilterOptions,
                        searchResetAction: setDocumentTypesFilterSearch,
                      });
                    }}
                    value={documentTypesFieldOptions.filter((o) =>
                      episodeListFilterObj.document_name?.includes(o.value),
                    )}
                  />
                </Grid>
              )}

              {/* LOS */}
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <label htmlFor="los_op" className="episodelist-filter-label">
                  LOS Operator
                </label>
                <Select
                  options={losOperatorOptions}
                  placeholder="Select Operator"
                  value={
                    episodeListFilterObj.los_op
                      ? losOperatorOptions.find(
                          (o) => o.value === episodeListFilterObj.los_op,
                        )
                      : ""
                  }
                  onChange={(selected) => {
                    dispatch(
                      setEpisodeListFilterObj({
                        ...episodeListFilterObj,
                        los_op: selected?.value || "",
                        length_of_stay: [],
                      }),
                    );
                  }}
                  classNamePrefix="react-select"
                />
              </Grid>
              {/* Single LOS value */}
              {!["gtlt", "gtelte"].includes(episodeListFilterObj.los_op) && (
                <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                  <label
                    htmlFor="length_of_stay"
                    className="episodelist-filter-label"
                  >
                    Length of Stay (LOS)
                  </label>
                  <div
                    className={`${
                      !episodeListFilterObj.los_op ? "datepicker-tooltip" : ""
                    }`}
                    data-title={"Select LOS operator to enable"}
                  >
                    <input
                      type="number"
                      min="0"
                      className="workflow-him-filter-input"
                      value={episodeListFilterObj.length_of_stay?.[0] ?? ""}
                      disabled={!episodeListFilterObj.los_op}
                      onKeyDown={(e) => {
                        if (e.key === "e" || e.key === "E") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        dispatch(
                          setEpisodeListFilterObj({
                            ...episodeListFilterObj,
                            length_of_stay: value === "" ? [] : [Number(value)],
                          }),
                        );
                      }}
                      placeholder="Enter LOS"
                    />
                  </div>
                </Grid>
              )}

              {/* LOS Range */}
              {["gtlt", "gtelte"].includes(episodeListFilterObj.los_op) && (
                <>
                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <label className="episodelist-filter-label">LOS From</label>
                    <input
                      type="number"
                      min="0"
                      className="workflow-him-filter-input"
                      value={episodeListFilterObj.length_of_stay?.[0] ?? ""}
                      onChange={(e) => {
                        const value = e.target.value;

                        dispatch(
                          setEpisodeListFilterObj({
                            ...episodeListFilterObj,
                            length_of_stay:
                              value === ""
                                ? []
                                : [
                                    Number(value),
                                    episodeListFilterObj.length_of_stay?.[1] ??
                                      null,
                                  ],
                          }),
                        );
                      }}
                      placeholder="From days"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <label className="episodelist-filter-label">LOS To</label>
                    <input
                      type="number"
                      min="0"
                      className="workflow-him-filter-input"
                      value={episodeListFilterObj.length_of_stay?.[1] ?? ""}
                      onChange={(e) => {
                        const value = e.target.value;

                        dispatch(
                          setEpisodeListFilterObj({
                            ...episodeListFilterObj,
                            length_of_stay:
                              episodeListFilterObj.length_of_stay?.[0] ===
                                undefined && value === ""
                                ? []
                                : [
                                    episodeListFilterObj.length_of_stay?.[0],
                                    value === "" ? undefined : Number(value),
                                  ],
                          }),
                        );
                      }}
                      placeholder="To days"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </form>
        </Modal.Body>
        <Modal.Footer className="episode-list-filter-modal-footer">
          <Button
            variant="secondary"
            type="button"
            className="el-filter-cancel"
            onClick={() => {
              closeEpisodeFilterModal();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="el-filter-submit"
            type="submit"
            onClick={EpisodeListFilterSubmit}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EpisodeListFilter;
